module.exports = __webpack_public_path__ + "img/beach-blue.c819cac8.svg";